export const FORM_TEMPLATES = {
  blank: {
    id: 'blank',
    label: 'Blank form',
    title: '',
    description: '',
    fields: []
  },
  'si-her-defi': {
    id: 'si-her-defi',
    label: 'Si Her DeFi Application',
    title: 'Si Her DeFi Application',
    description: 'Complete our application to join SI Her DeFi. The $300 USD one-time lifetime membership fee is for women or non-binary humans actively building in Web3. After your application is approved, we will send payment and onboarding info.',
    slug: 'siherdefi-application',
    showLoadingScreen: false,
    formsReferralsSection: true,
    buttonColor: '#6B46FE',
    fields: [
      { id: 'f_name', label: 'Name', name: 'name', type: 'text', required: true, placeholder: 'Your name', options: [] },
      { id: 'f_email', label: 'Email', name: 'email', type: 'email', required: true, placeholder: 'Your email', options: [] },
      { id: 'f_interests', label: 'Please share your interests in joining our DAO', name: 'interests', type: 'text', required: true, placeholder: 'e.g., DeFi, community building, content creation', options: [] },
      { id: 'f_engagement', label: 'How are you actively engaging within Web3?', name: 'web3_engagement', type: 'text', required: true, placeholder: 'e.g., DAO contributor, builder, DeFi user', options: [] },
      {
        id: 'f_pronouns',
        label: 'Which pronouns do you most identify?',
        name: 'pronouns',
        type: 'checkbox',
        required: true,
        placeholder: '',
        options: ['She/Her/Hers', 'They/Them/Theirs', 'Other']
      },
      {
        id: 'f_values',
        label: 'Please share your values and what you are interested in contributing to and receiving from the DAO',
        name: 'values_contribution',
        type: 'textarea',
        required: true,
        placeholder: 'Write details here',
        options: []
      },
      {
        id: 'f_hear',
        label: 'How did you hear about our DAO?',
        name: 'hear_about_us',
        type: 'text',
        required: true,
        placeholder: 'Please tell us how you discovered our DAO',
        options: []
      },
      {
        id: 'f_fee',
        label: 'Do you agree to our one-time $300 membership fee (paid in cryptocurrency)? After your application has been approved, we will send you the payment and onboarding info.',
        name: 'fee_agreement',
        type: 'radio',
        required: true,
        placeholder: '',
        options: ['Yes', 'No']
      }
    ]
  }
};

export function buildTemplateFields(templateId) {
  const template = FORM_TEMPLATES[templateId] || FORM_TEMPLATES.blank;
  return JSON.parse(JSON.stringify(template.fields || []));
}
